import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/Products/ScarfProduct.tsx");
